'use strict';

import MetaStats from './metaStats';

export default MetaStats;
export { MetaStats };
